module.exports = __webpack_public_path__ + "img/mainstreet.49412095.png";